import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import { Popper, Tooltip } from "@mui/material";
import classNames from "classnames";
const getStyleBySize = (size) => {
    switch (size) {
        case "small":
            return { padding: "4px 10px", ...typography["Content.Caption02"] };
        case "medium":
            return { padding: "8px 10px", ...typography["Content.Body04"] };
        default:
            return { padding: "8px 10px", ...typography["Content.Body04"] };
    }
};
const StyledSolidPopper = styled(Popper, { shouldForwardProp: propsName => propsName !== "arrowStyle" && propsName !== "arrowSize" })(({ style, size, arrowStyle, arrowSize }) => ({
    ".MuiTooltip-tooltip": {
        backgroundColor: `${palette.black}B2`,
        borderRadius: "8px",
        ...getStyleBySize(size),
        ...style,
    },
    ".MuiTooltip-arrow": {
        fontSize: arrowSize,
    },
    ".MuiTooltip-arrow::before": {
        backgroundColor: `${palette.black}B2`,
        ...arrowStyle,
    },
}));
const StyledPlainPopper = styled(Popper, { shouldForwardProp: propsName => propsName !== "arrowStyle" && propsName !== "arrowSize" })(({ style, size, arrowStyle, arrowSize }) => ({
    ".MuiTooltip-tooltip": {
        boxShadow: `0px 2px 16px 0px ${palette.black}29`,
        backgroundColor: palette.white,
        border: `1px solid ${palette.grey020}`,
        color: palette.grey080,
        borderRadius: "8px",
        ...getStyleBySize(size),
        ...style,
    },
    ".MuiTooltip-arrow": {
        fontSize: arrowSize,
    },
    ".MuiTooltip-arrow::before": {
        backgroundColor: palette.white,
        border: `1px solid ${palette.grey020}`,
        ...arrowStyle,
    },
}));
const StyledButtonWrapper = styled.div(() => ({
    display: "inline-block",
    height: "fit-content",
}));
export function GrTooltip({ arrow = true, variant = "solid", style, arrowStyle, content, children, size = "medium", arrowSize, className, tabIndex = 0, ...props }) {
    return (_jsx(Tooltip, { className: classNames("GrTooltip", className), title: content, arrow: arrow, ...props, PopperComponent: variant === "solid"
            ? popperProps => _jsx(StyledSolidPopper, { ...popperProps, style: style, size: size, arrowStyle: arrowStyle, arrowSize: arrowSize })
            : popperProps => _jsx(StyledPlainPopper, { ...popperProps, style: style, size: size, arrowStyle: arrowStyle, arrowSize: arrowSize }), children: _jsx(StyledButtonWrapper, { tabIndex: tabIndex, children: children }) }));
}
//# sourceMappingURL=GrTooltip.js.map